import React, { useEffect } from 'react';

function Blog() {
  useEffect(() => {
    // Redirect to the static blog page
    window.location.href = '/blog.html';
  }, []);

  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <p>Redirecting to blog...</p>
    </div>
  );
}

export default Blog; 